#import "../../../../timeline/graphql/fragments/submission-fragment.graphql"

query GetSubmission($id: ID!) {
    submission(id: $id) {
        ...SubmissionFragment
        notificationLogs {
            id
            recipient {
                id
                name
            }
            sendType
            didNotSend
            createdTime
        }
    }
}
